export default [
  {
    name: 'recommand-manage',
    path: '/setting/recommand-manage',
    component: () =>
      import(
        /* webpackChunkName: "RecommandManage" */ '@/views/setting/recommand-manage'
      ),
    meta: { title: '推荐管理' },
  },
];
